import { createContext } from 'react'

import type { User } from './api/auth'

export interface AuthContextType {
  user: User | null
  isLoading: boolean
  isAuthenticated: boolean
  login: (user: User) => void
  logout: () => Promise<void>
  refreshUser: (options?: { allowCachedFallback?: boolean }) => Promise<void>
}

/**
 * Le contexte vit dans son propre module, sans composant à côté.
 *
 * `usePermissions` a besoin de le lire sans passer par `useAuth`, qui jette hors provider ; l'avoir
 * exporté depuis `auth-context.tsx` marchait, mais faisait de ce fichier un module mixte
 * composant + valeur, ce que `react-refresh/only-export-components` signale à juste titre : le HMR
 * du provider cassait. Un module de valeurs pures règle les deux.
 */
export const AuthContext = createContext<AuthContextType | undefined>(undefined)
